import React, {Component} from 'react'
import {Button} from 'reactstrap'
import PropTypes from 'prop-types'
import {graphql, withApollo} from 'react-apollo'
import {CreateExportWelders} from './mutations'
import {GET_JOBS} from '../../JobsNotifications/graphql'

class ExportWelderCertificateBtn extends Component {
  constructor() {
    super()
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    mutate: PropTypes.func.isRequired,
    certificate_id: PropTypes.number.isRequired,
    merge_by_cert_no: PropTypes.bool.isRequired,
    client: PropTypes.object.isRequired
  }

  handleSubmit(e) {
    e.stopPropagation()
    this.props.mutate({
      variables: {
        type: 'WlWelders::Jobs::ExportWelders',
        args: JSON.stringify({
          format: 'pdf',
          version: 'welder_certificate',
          certificate_id: this.props.certificate_id,
          merge_by_cert_no: this.props.merge_by_cert_no
        })
      }
    }).then(() => {
      this.props.client.query({
        query: GET_JOBS,
        fetchPolicy: 'network-only'
      }).then(({ data }) => {
        const notifyCount = data.user_jobs ? data.user_jobs.filter(job => job.notify).length : 0
        const event = new CustomEvent('changeNotifyCountInApp', { detail: { notifyCount } })
        window.dispatchEvent(event)
      })
    })
  }

  render() {
    return (
      <Button id="export-welder-certificate-btn" color="primary" title="Export" onClick={this.handleSubmit}>
        <i className="fa fa-print"/>
      </Button>
    )
  }
}

const ExportWelderCertificateWithMutation = graphql(CreateExportWelders)(ExportWelderCertificateBtn)

export default withApollo(ExportWelderCertificateWithMutation)



// WEBPACK FOOTER //
// ./src/components/Welders/export_welders/ExportWelderCertificateBtn.js